module.exports = __webpack_public_path__ + "assets/link.ccb9111d.svg";